var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"buttons-wrapper"},[(_vm.isLoggedIn)?_c('AccountTeaser'):_c('LoginButton'),_vm._v(" "),_c('LoginModal')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }